import script from "./background.vue?vue&type=script&setup=true&lang=js"
export * from "./background.vue?vue&type=script&setup=true&lang=js"

import "./background.vue?vue&type=style&index=0&id=3d50fc1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d50fc1a"]])

export default __exports__